import type { Cell, RowData } from '@tanstack/react-table';
import { flexRender } from '@tanstack/react-table';

interface DataGridCellProps<T> {
  cell: Cell<T, unknown>;
  cellClassName?: string;
}

export function DataGridCell<T extends RowData>({
  cell,
  cellClassName,
}: DataGridCellProps<T>) {
  const columnClassName = cell.column.columnDef.meta?.columnClassName ?? '';
  const cellStyle = cell.column.columnDef.meta?.cellStyle ?? {};
  const { allowTextWrap = false, ...otherStyles } = cellStyle;

  return (
    <td
      className={`${
        allowTextWrap ? '' : 'whitespace-nowrap'
      } px-3 py-3 text-sm text-gray-500 ${cellClassName} ${columnClassName}`.trim()}
      style={Object.keys(otherStyles).length > 0 ? otherStyles : undefined}
    >
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </td>
  );
}
